import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventInputFieldScroll]'
})
export class PreventInputFieldScrollDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    const input = event.target as HTMLElement;
    input.blur();
  }
}
